import { TransportManager } from "@econ-v1/domain";
import { probeLanCandidate } from "./lan-probe.js";
import { createWanHomeNodeClient } from "./wan-client.js";
import { WebTransportHomeNodeClient } from "./webtransport/webtransport-home-node-client.js";
import { BrowserDelay } from "../clock/browser-delay.js";
export function createBrowserTransportManager(options) {
    return new TransportManager({
        ...options,
        candidates: options.candidates,
        delay: options.delay ?? new BrowserDelay(),
        dial: async (candidate, signal) => {
            if (candidate.path === "lan-direct")
                return await probeLanCandidate(candidate, options.lan, signal);
            if (candidate.path === "lan-webtransport")
                return await dialWebTransport(candidate, options);
            const client = await createWanHomeNodeClient(candidate, options.wan, signal);
            try {
                await client.ready(signal);
                return client;
            }
            catch (error) {
                client.close();
                throw error;
            }
        },
    });
}
async function dialWebTransport(candidate, options) {
    if (options.webtransport === undefined) {
        throw new TypeError("A WebTransport candidate was offered without webtransport dial options");
    }
    const transportIdentity = await options.webtransport.transportIdentity();
    return new WebTransportHomeNodeClient({
        candidate,
        setupHeaders: async () => {
            const headers = {};
            const accessToken = await options.wan.accessToken?.();
            if (accessToken !== undefined)
                headers.authorization = `Bearer ${accessToken}`;
            const delegation = await options.wan.delegationCredential?.();
            if (delegation !== undefined)
                headers["x-client-device-delegation"] = delegation;
            return headers;
        },
        transportIdentity,
        ...(options.webtransport.webTransportFactory === undefined
            ? {}
            : { webTransportFactory: options.webtransport.webTransportFactory }),
    });
}
//# sourceMappingURL=transport-manager.js.map